import type { Copy } from "../types";

export const ja: Copy = {
    seo: {
      title: "車齢計算機 | 年と月で車両年齢をチェック",
      description:
        "製造年と任意の月から車両の正確な年齢を確認できます。年、月、日、合計日数、節目を1つのシンプルな計算機で表示します。",
      keywords: [
        "車齢計算機",
        "車両年齢計算機",
        "車の製造年チェック",
        "車両製造月チェック",
        "車は何年式",
        "車齢確認",
        "車両年齢チェック",
        "RC 年齢計算機",
        "車の年齢を月で確認",
        "車両日付計算機",
        "mParivahan 代替",
        "Parivahan 代替",
        "RTO 車両年齢計算機",
        "車両登録年齢",
        "車登録年齢",
      ],
      faq: [
        {
          question: "この計算機は何をしますか？",
          answer:
            "選択した製造年と任意の月から車両の正確な年齢を計算し、年、月、日、節目を表示します。",
        },
        {
          question: "なぜ任意の月があるのですか？",
          answer:
            "月を追加すると、より正確な年齢になります。月を選ばない場合は、選択した年の1月を使用します。",
        },
        {
          question: "未来の年や月は選べますか？",
          answer:
            "いいえ。未来の年は選べず、選択した年が今年の場合は未来の月も無効になります。",
        },
      ],
    },
    headerTagline: "車両ツール",
    headerTitle: "車齢計算機",
    reset: "リセット",
    switchToLight: "ライトモードに切り替え",
    switchToDark: "ダークモードに切り替え",
    languageLabel: "言語",
    languageEnglish: "英語",
    languageHindi: "ヒンディー語",
    heroEyebrow: "車齢を、わかりやすく",
    heroTitle: "車両年齢を調べるためのシンプルな日付ツール。",
    heroDescription: "製造年を選択してください。より正確にしたい場合のみ月を追加します。",
    yearSelectLabel: "製造年",
    monthSelectLabel: "製造月",
    includeMonthLabel: "より正確にするため特定の月を含める",
    includeMonthNote: "月を含めない場合は、計算に1月を使用します。",
    yearOnlyBadge: "年のみ",
    yearMonthBadge: "年 + 月",
    yearPlaceholder: "年を選択",
    monthPlaceholder: "月を選択",
    inputTitle: "製造年",
    inputLabel: "製造年",
    blockedDateNote: "未来の年は選べません。",
    result: "結果",
    vehicleAgeLead: "あなたの車は",
    asOfToday: "今日時点",
    years: "年",
    months: "か月",
    days: "日",
    totalDays: (count) => `${count.toLocaleString("en-IN")}日経過`,
    ageLabels: { almostNew: "ほぼ新車", modern: "現代的", mature: "成熟", classic: "クラシック" },
    estimatedValue: {
      high: "高い再販余地",
      healthy: "安定した価値保持",
      moderate: "中程度の減価",
      collector: "コレクター需要が高まる可能性",
    },
    maintenanceTitle: "メンテナンス",
    maintenance: {
      routine: "定期点検と純正整備",
      watch: "ブレーキ、液体、タイヤに注意",
      plan: "消耗品と点検の計画を立てる",
      specialized: "専門的な整備の重要性が増します",
    },
    registrationTitle: "登録",
    registration: {
      collector: "地域によってはコレクター向けの扱いになる場合があります",
      classic: "地域によってはクラシックカー扱いの登録が適用されます",
      standard: "通常の更新と地域確認を想定してください",
      regular: "一般的には通常登録が適用されます",
    },
    upcomingMilestoneTitle: "次の節目",
    milestoneTimelineTitle: "節目のタイムライン",
    milestoneRemaining: ({ label, days }) => `${label}まであと${days.toLocaleString("ja-JP")}日`,
    reached: "達成済み",
    upcoming: "次回",
    allMilestonesReachedTitle: "表示されている節目はすべて達成済みです",
    allMilestonesReachedBody:
      "この車両は、現在アプリに表示されている節目範囲を超えています。",
    copySummary: "要約をコピー",
    shareResult: "結果を共有",
    resetMessage: "計算機をリセットしました",
    summaryCopied: "要約をクリップボードにコピーしました",
    clipboardFailed: "クリップボードへのアクセスに失敗しました",
    emptyTitle: "製造年を選ぶと詳細が表示されます",
    emptyDescription:
      "年を選択すると、正確な年齢、合計日数、メンテナンス、クラシック状態、節目の時期が表示されます。",
    shareTitle: "車齢計算機",
    summary: ({ label, years, months, days, asOf }) =>
      `${label} に製造された私の車は、${asOf} 時点で ${years} 年 ${months} か月 ${days} 日です。`,
    milestones: {
      1: { label: "1年目", note: "保証や整備計画に役立ちます。" },
      3: { label: "3年目", note: "再販や価格変動でよく見られる時期です。" },
      5: { label: "5年目", note: "整備予算を見直すのに適した時期です。" },
      10: { label: "10年目", note: "経年部品への注意が必要です。" },
      15: { label: "15年目", note: "多くの地域でクラシック扱いが始まることがあります。" },
      25: { label: "25年目", note: "一部市場ではコレクターや輸入向けになりやすいです。" },
    },
  };
